module.exports = __webpack_public_path__ + "img/Mask-Watercolor-sign-up.76829d66.png";